import { LicenseManager } from 'ag-grid-enterprise';
import { LicenseManager as AgChartsLicenseManager } from 'ag-charts-enterprise';

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;
if (licenseKey) {
  LicenseManager.setLicenseKey(licenseKey);
  // AG Charts v13 has its own LicenseManager separate from AG Grid's;
  // the AG Grid Enterprise key also licenses AG Charts Enterprise.
  AgChartsLicenseManager.setLicenseKey(licenseKey);
}

export * from 'ag-grid-enterprise';
export * from 'ag-grid-react';